import UAParser from 'ua-parser-js';

class OperatingSystemService {
  constructor() {
    this.parser = new UAParser();
  }

  isMac() {
    const { name: OSName } = this.parser.getOS();
    if (!OSName) {
      return false;
    }
    return OSName.toLowerCase().indexOf('mac') !== -1;
  }
}

export default new OperatingSystemService();
